<template>
  <div id="app" class="w-full">
    <router-view />
    <div>
      <audio ref="audio-original" controls class="hidden">
        <source src="/audio/original.mp3" type="audio/mpeg" />
      </audio>
      <audio ref="audio-vocals-0" controls class="hidden">
        <source src="/audio/final.mp3" type="audio/mpeg" />
      </audio>
      <audio ref="audio-vocals-1" class="hidden">
        <source src="/audio/tracks/1.mp3" type="audio/mpeg" />
      </audio>
      <audio ref="audio-vocals-2" class="hidden">
        <source src="/audio/tracks/2.mp3" type="audio/mpeg" />
      </audio>
      <audio ref="audio-vocals-3" class="hidden">
        <source src="/audio/tracks/3.mp3" type="audio/mpeg" />
      </audio>
      <audio ref="audio-vocals-4" class="hidden">
        <source src="/audio/tracks/4.mp3" type="audio/mpeg" />
      </audio>
      <audio ref="audio-vocals-5" class="hidden">
        <source src="/audio/tracks/5.mp3" type="audio/mpeg" />
      </audio>
      <audio ref="audio-vocals-6" class="hidden">
        <source src="/audio/tracks/6.mp3" type="audio/mpeg" />
      </audio>
      <audio ref="audio-vocals-7" class="hidden">
        <source src="/audio/tracks/7.mp3" type="audio/mpeg" />
      </audio>
      <audio ref="audio-vocals-8" class="hidden">
        <source src="/audio/tracks/8.mp3" type="audio/mpeg" />
      </audio>
      <audio ref="audio-vocals-9" class="hidden">
        <source src="/audio/tracks/9.mp3" type="audio/mpeg" />
      </audio>
      <audio ref="audio-vocals-10" class="hidden">
        <source src="/audio/tracks/10.mp3" type="audio/mpeg" />
      </audio>
      <audio ref="audio-vocals-11" class="hidden">
        <source src="/audio/tracks/11.mp3" type="audio/mpeg" />
      </audio>
      <audio ref="audio-vocals-12" class="hidden">
        <source src="/audio/tracks/12.mp3" type="audio/mpeg" />
      </audio>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",

  mounted() {
    window.players = {
      "audio-original": this.$refs["audio-original"],
      "audio-vocals-0": this.$refs["audio-vocals-0"],
      "audio-vocals-1": this.$refs["audio-vocals-1"],
      "audio-vocals-2": this.$refs["audio-vocals-2"],
      "audio-vocals-3": this.$refs["audio-vocals-3"],
      "audio-vocals-4": this.$refs["audio-vocals-4"],
      "audio-vocals-5": this.$refs["audio-vocals-5"],
      "audio-vocals-6": this.$refs["audio-vocals-6"],
      "audio-vocals-7": this.$refs["audio-vocals-7"],
      "audio-vocals-8": this.$refs["audio-vocals-8"],
      "audio-vocals-9": this.$refs["audio-vocals-9"],
      "audio-vocals-10": this.$refs["audio-vocals-10"],
      "audio-vocals-11": this.$refs["audio-vocals-11"],
      "audio-vocals-12": this.$refs["audio-vocals-12"]
    };
  }
};
</script>

<style>
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
